// SAB-430: Section I — Final CTA with floating bomb.
// Last conversion surface before the footer. Single Browse Leagues button
// reuses the existing analytics event with placement='final_cta'.
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { trackEvent } from '@/lib/analytics';

export function FinalCTA() {
  const trackBrowse = () =>
    trackEvent('homepage_browse_leagues_click', { source: 'homepage', placement: 'final_cta' });

  return (
    <section className="relative overflow-hidden border-t border-border">
      {/* Radial orange glow overlay */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'var(--gradient-glow)' }}
      />

      {/* SAB-445: section padding 60→40 on mobile, smaller bomb + H1 floor. */}
      <div className="relative mx-auto max-w-[760px] px-6 py-10 sm:py-[60px] text-center">
        <img
          src="/images/bomb.png"
          alt=""
          aria-hidden
          className="w-14 h-14 sm:w-[72px] sm:h-[72px] mx-auto mb-4 sm:mb-5 block"
          style={{
            animation: 'sf-cta-float 4s ease-in-out infinite',
            filter: 'drop-shadow(0 0 20px hsl(25 95% 53% / 0.4))',
          }}
        />
        {/* SAB-445: lower clamp floor 2.2rem → 1.8rem so mobile H2 drops from
            40px to 32px. Desktop unchanged (5vw + max). */}
        <h2
          className="font-varsity m-0 mb-3 sm:mb-4 leading-[1.05]"
          style={{ fontSize: 'clamp(1.8rem, 5vw, 3.6rem)' }}
        >
          Ready to <span className="text-gradient-sabotage">sabotage?</span>
        </h2>
        <p className="text-[16px] sm:text-[18px] text-muted-foreground max-w-[480px] mx-auto mb-5 sm:mb-7">
          Build the most chaotic fantasy team ever drafted. NFL leagues open in July. Lock
          yours in before the season kicks off in September.
        </p>
        <Button
          asChild
          variant="default"
          className="h-[52px] px-10 text-[17px]"
        >
          <Link to="/nfl/leagues/browse" onClick={trackBrowse}>
            Browse Leagues →
          </Link>
        </Button>
      </div>

      <style>{`
        @keyframes sf-cta-float {
          0%, 100% { transform: translateY(0)     rotate(-6deg); }
          50%      { transform: translateY(-14px) rotate(-6deg); }
        }
      `}</style>
    </section>
  );
}

export default FinalCTA;
